import { Component, inject, signal, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectivityService } from '../../services/connectivity.service';

const RECONNECTED_DURATION_MS = 4000;

/**
 * Banner global de estado de conexión.
 * - Sin conexión: se muestra siempre el aviso.
 * - Al reconectar: se muestra "Conectado" unos segundos y luego se oculta.
 */
@Component({
  selector: 'app-connectivity-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './connectivity-banner.component.html',
  styleUrl: './connectivity-banner.component.css',
})
export class ConnectivityBannerComponent {
  private readonly connectivity = inject(ConnectivityService);

  readonly isOnline = this.connectivity.isOnline$;
  /** true durante unos segundos tras pasar de offline a online (no al cargar ya conectado) */
  readonly showReconnectedBanner = signal(false);

  private wasOffline = false;
  private reconnectedTimeoutId: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    effect(() => {
      const online = this.connectivity.isOnline();
      if (online) {
        if (this.wasOffline) {
          this.showReconnectedBanner.set(true);
          this.wasOffline = false;
          if (this.reconnectedTimeoutId != null) clearTimeout(this.reconnectedTimeoutId);
          this.reconnectedTimeoutId = setTimeout(() => {
            this.showReconnectedBanner.set(false);
            this.reconnectedTimeoutId = null;
          }, RECONNECTED_DURATION_MS);
        }
      } else {
        this.wasOffline = true;
        this.showReconnectedBanner.set(false);
        if (this.reconnectedTimeoutId != null) {
          clearTimeout(this.reconnectedTimeoutId);
          this.reconnectedTimeoutId = null;
        }
      }
    });
  }
}
